import "./RequestDemo.module.css";
import Header from "@/reusable_sections/Header";
import DemoIntroduction from "./sections/DemoIntroduction";
import ContactForm from "./sections/ContactForm";
import WhyJoinFreshMart from "./sections/WhyJoinFreshMart";
import Footer from "@/reusable_sections/Footer";
export default function RequestDemoPage() {
  return <div>
      <Header />
      <DemoIntroduction />
      <ContactForm />
      <WhyJoinFreshMart />
      <Footer />
    </div>;
}